import { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { comics } from "@/mocks/comics";

const MOCK_CHAPTERS = [
  { num: 86, title: "最终选择", date: "2026-08-03" },
  { num: 85, title: "社长的心意", date: "2026-07-27" },
  { num: 84, title: "无法隐藏的真心", date: "2026-07-20" },
  { num: 83, title: "雨中的告白", date: "2026-07-13" },
  { num: 82, title: "身份暴露", date: "2026-07-06" },
  { num: 81, title: "危机降临", date: "2026-06-29" },
  { num: 80, title: "意外的相遇", date: "2026-06-22" },
  { num: 79, title: "内心的挣扎", date: "2026-06-15" },
  { num: 78, title: "新的开始", date: "2026-06-08" },
  { num: 77, title: "过往的秘密", date: "2026-06-01" },
  { num: 76, title: "深夜的电话", date: "2026-05-25" },
  { num: 75, title: "无法言说的爱", date: "2026-05-18" },
];

const READING_PANELS: string[] = [
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20comic%20panel%20illustration%20with%20characters%20in%20dramatic%20scene%2C%20clean%20lineart%2C%20professional%20coloring%2C%20emotional%20expressions%2C%20vertical%20scroll%20format%2C%20modern%20webtoon%20aesthetic&width=800&height=800&seq=reading-01-gen&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20comic%20panel%20illustration%20with%20characters%20in%20romantic%20scene%2C%20clean%20lineart%2C%20soft%20colors%2C%20vertical%20scroll%20format%2C%20modern%20webtoon%20aesthetic&width=800&height=900&seq=reading-02-gen&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20comic%20panel%20illustration%20action%20scene%20with%20dynamic%20poses%2C%20clean%20lineart%2C%20professional%20coloring%2C%20vertical%20scroll%20format%2C%20modern%20webtoon&width=800&height=700&seq=reading-03-gen&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20comic%20panel%20illustration%20emotional%20dialogue%20scene%2C%20clean%20lineart%2C%20warm%20colors%2C%20vertical%20scroll%20format%2C%20modern%20webtoon%20aesthetic&width=800&height=850&seq=reading-04-gen&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20comic%20panel%20illustration%20dramatic%20reveal%20scene%2C%20clean%20lineart%2C%20professional%20coloring%2C%20vertical%20scroll%20format%2C%20modern%20webtoon&width=800&height=750&seq=reading-05-gen&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20comic%20panel%20illustration%20tender%20moment%20between%20characters%2C%20clean%20lineart%2C%20soft%20pastel%20colors%2C%20vertical%20scroll%20format%2C%20modern%20webtoon&width=800&height=950&seq=reading-06-gen&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20comic%20panel%20illustration%20suspenseful%20cliffhanger%20scene%2C%20clean%20lineart%2C%20dark%20tones%2C%20vertical%20scroll%20format%2C%20modern%20webtoon&width=800&height=650&seq=reading-07-gen&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20comic%20panel%20illustration%20happy%20ending%20scene%2C%20clean%20lineart%2C%20bright%20warm%20colors%2C%20vertical%20scroll%20format%2C%20modern%20webtoon%20aesthetic&width=800&height=880&seq=reading-08-gen&orientation=portrait",
];

export default function ComicDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [tab, setTab] = useState<"info" | "chapters">("info");
  const [readingMode, setReadingMode] = useState(false);
  const [currentChapter, setCurrentChapter] = useState<number | null>(null);
  const topRef = useRef<HTMLDivElement>(null);

  const comic = comics.find((c) => c.id === Number(id));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [id]);

  useEffect(() => {
    if (readingMode && topRef.current) {
      topRef.current.scrollIntoView({ behavior: "instant" });
    }
  }, [readingMode]);

  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  if (!comic) {
    return (
      <main>
        <Navbar />
        <div className="pt-32 pb-20 text-center">
          <p className="text-foreground-500">漫画未找到</p>
          <Link to="/" className="text-primary-500 hover:text-primary-600 mt-4 inline-block">
            返回首页
          </Link>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main ref={topRef}>
      {/* BreadcrumbList Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "首页",
                item: "https://073manga.com",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: `${comic.category}漫画`,
                item: `https://073manga.com/category/${comic.category}`,
              },
              {
                "@type": "ListItem",
                position: 3,
                name: comic.title,
                item: `https://073manga.com/comic/${comic.id}`,
              },
            ],
          }),
        }}
      />

      {/* Article Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: `${comic.title} - 韩国漫画免费在线阅读`,
            description: comic.description,
            author: {
              "@type": "Person",
              name: comic.author,
            },
            datePublished: "2024-01-01",
            dateModified: comic.updateDate,
            image: comic.cover,
            publisher: {
              "@type": "Organization",
              name: "073漫画网",
            },
          }),
        }}
      />

      <Navbar />

      {!readingMode ? (
        <>
          {/* Comic Header */}
          <section className="pt-24 pb-10 bg-background-50">
            <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
              {/* Breadcrumb */}
              <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6 flex-wrap" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  首页
                </Link>
                <i className="ri-arrow-right-s-line"></i>
                <Link
                  to={`/category/${comic.category}`}
                  className="hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {comic.category}漫画
                </Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-foreground-600 truncate">{comic.title}</span>
              </nav>

              <div className="flex flex-col md:flex-row gap-8">
                {/* Cover */}
                <div className="flex-shrink-0 w-48 md:w-56 mx-auto md:mx-0">
                  <div className="aspect-[3/4] rounded-xl overflow-hidden">
                    <img
                      src={comic.cover}
                      alt={`${comic.title} - 韩国漫画`}
                      title={`${comic.title} - 韩国漫画免费在线阅读`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>

                {/* Info */}
                <div className="flex-1 min-w-0">
                  <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
                    {comic.title}
                  </h1>
                  <p className="text-sm text-foreground-500 mb-4">
                    作者：<strong>{comic.author}</strong>
                  </p>

                  <div className="flex flex-wrap items-center gap-2 mb-4">
                    <span
                      className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                        comic.status === "连载中"
                          ? "bg-primary-100 text-primary-700"
                          : "bg-foreground-200 text-foreground-600"
                      }`}
                    >
                      {comic.status}
                    </span>
                    {comic.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  <div className="flex items-center gap-5 text-sm text-foreground-500 mb-6">
                    <span className="flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-xs"></i>
                      </span>
                      <strong className="text-foreground-800">{comic.rating}</strong>
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-eye-line text-xs"></i>
                      </span>
                      {formatViews(comic.views)} 次阅读
                    </span>
                    <span>
                      共 <strong className="text-foreground-800">{comic.chapters}</strong> 话
                    </span>
                  </div>

                  <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                    {comic.description}
                  </p>

                  <div className="flex flex-col sm:flex-row gap-3">
                    <button
                      onClick={() => {
                        setReadingMode(true);
                        setCurrentChapter(comic.chapters);
                      }}
                      className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors flex items-center justify-center gap-2 whitespace-nowrap"
                    >
                      <i className="ri-play-circle-line"></i>
                      开始阅读（第{comic.chapters}话）
                    </button>
                    <button
                      onClick={() => setTab("chapters")}
                      className="px-8 py-3 border border-background-300 text-foreground-700 rounded-full font-semibold text-sm hover:bg-background-100 transition-colors flex items-center justify-center gap-2 whitespace-nowrap"
                    >
                      <i className="ri-list-check"></i>
                      章节列表
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Tabs */}
          <section className="border-b border-background-200 bg-background-50 sticky top-16 z-30">
            <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
              <div className="flex items-center gap-1">
                <button
                  onClick={() => setTab("info")}
                  className={`px-5 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                    tab === "info"
                      ? "border-primary-500 text-primary-600"
                      : "border-transparent text-foreground-500 hover:text-foreground-700"
                  }`}
                >
                  作品详情
                </button>
                <button
                  onClick={() => setTab("chapters")}
                  className={`px-5 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                    tab === "chapters"
                      ? "border-primary-500 text-primary-600"
                      : "border-transparent text-foreground-500 hover:text-foreground-700"
                  }`}
                >
                  章节列表（{comic.chapters}话）
                </button>
              </div>
            </div>
          </section>

          {/* Tab Content */}
          <section className="py-10 bg-background-50 min-h-[300px]">
            <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
              {tab === "info" && (
                <div className="prose prose-sm max-w-none">
                  <h2 className="text-lg font-semibold text-foreground-900 font-heading mb-3">作品简介</h2>
                  <p className="text-sm text-foreground-600 leading-relaxed">{comic.description}</p>
                  <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-4">
                    <div className="p-4 rounded-xl bg-background-100">
                      <div className="text-xs text-foreground-400">作者</div>
                      <div className="text-sm font-medium text-foreground-800 mt-1">{comic.author}</div>
                    </div>
                    <div className="p-4 rounded-xl bg-background-100">
                      <div className="text-xs text-foreground-400">状态</div>
                      <div className="text-sm font-medium text-foreground-800 mt-1">{comic.status}</div>
                    </div>
                    <div className="p-4 rounded-xl bg-background-100">
                      <div className="text-xs text-foreground-400">总话数</div>
                      <div className="text-sm font-medium text-foreground-800 mt-1">{comic.chapters} 话</div>
                    </div>
                  </div>
                </div>
              )}

              {tab === "chapters" && (
                <div>
                  <h2 className="text-lg font-semibold text-foreground-900 font-heading mb-4">全部章节</h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
                    {MOCK_CHAPTERS.map((ch) => (
                      <button
                        key={ch.num}
                        onClick={() => {
                          setReadingMode(true);
                          setCurrentChapter(ch.num);
                        }}
                        className="flex items-center justify-between px-4 py-3 rounded-xl bg-background-100 hover:bg-primary-100/50 transition-colors text-left group"
                      >
                        <div className="min-w-0">
                          <div className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 truncate">
                            第{ch.num}话 {ch.title}
                          </div>
                          <div className="text-xs text-foreground-400 mt-0.5">{ch.date}</div>
                        </div>
                        <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-300 group-hover:text-primary-500">
                          <i className="ri-arrow-right-s-line"></i>
                        </span>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </section>
        </>
      ) : (
        /* Reading Mode */
        <>
          {/* Reading toolbar */}
          <section className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
            <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6 flex items-center justify-between h-14">
              <button
                onClick={() => setReadingMode(false)}
                className="flex items-center gap-1 text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </span>
                返回详情
              </button>
              <span className="text-sm font-medium text-foreground-800 truncate">
                {comic.title} - 第{currentChapter}话
              </span>
              <div className="flex items-center gap-3">
                <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-100 text-foreground-500 transition-colors">
                  <i className="ri-settings-3-line"></i>
                </button>
              </div>
            </div>
          </section>

          {/* Reading content - Scroll style */}
          <section className="pt-14 pb-10 bg-background-950">
            <div className="w-full max-w-[800px] mx-auto">
              {/* Simulated scroll reading panels */}
              {READING_PANELS.map((panelUrl, i) => (
                <div key={i} className="mb-1">
                  <img
                    src={panelUrl}
                    alt={`${comic.title} 第${currentChapter}话 ${i + 1}`}
                    title={`${comic.title} 第${currentChapter}话 第${i + 1}页`}
                    className="w-full h-auto"
                  />
                </div>
              ))}

              {/* Chapter navigation */}
              <div className="flex items-center justify-between px-4 py-6">
                <button
                  className="px-5 py-2.5 bg-background-800 text-background-200 rounded-full text-sm font-medium hover:bg-background-700 transition-colors flex items-center gap-1 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed"
                  disabled={!currentChapter || currentChapter <= 1}
                >
                  <i className="ri-arrow-left-line"></i>
                  上一话
                </button>
                <button
                  onClick={() => setReadingMode(false)}
                  className="px-5 py-2.5 bg-background-800 text-background-200 rounded-full text-sm font-medium hover:bg-background-700 transition-colors whitespace-nowrap"
                >
                  返回目录
                </button>
                <button
                  className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed"
                  disabled={!currentChapter || currentChapter >= comic.chapters}
                >
                  下一话
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </section>
        </>
      )}

      <Footer />
    </main>
  );
}